import React from 'react';
import { DowngradeModalContext } from '../components/DowngradeModalContext';
export const useDowngradeModalContext = () => {
  return React.useContext(DowngradeModalContext);
};
//# sourceMappingURL=useDowngradeModalContext.js.map